// Module
var code = " <button [disabled]=\"disabled\" mat-raised-button=\"\" color=\"primary\" type=\"button\" (click)=\"openRequestDialog()\" data-automation-id=\"modify-btn\">{{'lbl_modify' | translate}}</button>";
// Exports
module.exports = code;